import React, {Fragment} from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {PreviewCardTitleProps} from './types';

const {preview} = translations['pt-br'].commons;

export function PreviewCardTitle({highlightedText}: PreviewCardTitleProps) {
	return (
		<Fragment>
			<Typography fontSize="1.25rem" component="span">
				{preview}
			</Typography>{' '}
			{highlightedText}
		</Fragment>
	);
}
